module.exports = __webpack_public_path__ + "static/media/culture-banner-img.7fc9ad4e.png";